import React from "react"
import PropTypes from "prop-types"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline"
import { AnchorLink } from "gatsby-plugin-anchor-links"

const PaginationWithApi = ({
  slug,
  currentPage,
  setCurrentPage,
  total,
  limit,
}) => {
  if (!currentPage || !total) {
    return null
  }

  const numPages = Math.ceil(total / limit)
  // 判斷第一頁
  const isFirst = currentPage === 1

  // 判斷最後一頁
  const isLast = currentPage === numPages

  const anchorLinks = Array.from({ length: numPages }, (_, idx) => {
    // page：迴圈頁數，currentPage：當前頁面頁數
    const page = idx + 1

    // 判斷是否顯示該頁數（在 currentPage +-2 範圍時以及第一頁與最後一頁顯示）
    const isDisplayPage =
      (page > currentPage - 3 && page < currentPage + 3) ||
      page === 1 ||
      page === numPages

    // 判斷顯示 "..." 的 bool
    const isReplaceDot =
      (page === currentPage + 3 || page === currentPage - 3) &&
      page !== 1 &&
      page !== numPages

    return isReplaceDot ? (
      <p key={`pagination-number${page}`} className="translate-y-1">
        ...
      </p>
    ) : (
      <AnchorLink key={`pagination-number${page}`} to={`/${slug}#anchor_link`}>
        <button
          className={`px-3 py-1 h-8 w-8 flex justify-center items-center rounded hover:border hover:border-gray-300 ${
            page === currentPage
              ? "border border-neutral-500 hover:border-neutral-300"
              : ""
          } ${isDisplayPage ? "block" : "hidden"}`}
          onClick={e => {
            setCurrentPage(Number(e.target.textContent))
          }}
        >
          {page}
        </button>
      </AnchorLink>
    )
  })
  return (
    <div className="text-neutral-500 flex space-x-1 justify-center mt-4 sm:space-x-2">
      <AnchorLink to={`/${slug}#anchor_link`}>
        <button
          className={`justify-center items-center px-3 py-1 ${
            isFirst ? "hidden" : "flex"
          }`}
          onClick={() => {
            setCurrentPage(prev => prev - 1)
          }}
        >
          <ChevronLeftIcon
            className="h-5 w-5 text-amber-400"
            aria-hidden="true"
          />
        </button>
      </AnchorLink>
      {anchorLinks}
      <AnchorLink to={`/${slug}#anchor_link`}>
        <button
          className={`justify-center items-center px-3 py-1 ${
            isLast ? "hidden" : "flex"
          }`}
          onClick={() => {
            setCurrentPage(prev => prev + 1)
          }}
        >
          <ChevronRightIcon
            className="h-5 w-5 text-amber-400"
            aria-hidden="true"
          />
        </button>
      </AnchorLink>
    </div>
  )
}

PaginationWithApi.propTypes = {
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
  total: PropTypes.number,
  limit: PropTypes.number,
  slug: PropTypes.string,
}

export default PaginationWithApi
